<template>
  <div v-if="(operation.licenses && operation.documents.length > 0) || operation.state_license" class="col-12 col-lg-6 d-flex flex-column p-3">
    <OperationsTitle name="Licenses" />
    <OperationLicensesList
      :licenses="operation.licenses"
      :is-downloadable="!!operation.state_license_doc"
      :state-license-doc="operation.state_license_doc"
      :state-license="operation.state_license"
    />
  </div>
</template>

<script>
import OperationsTitle from "../common/OperationsTitle.vue";
import OperationLicensesList from "@/components/licenses/OperationLicensesList.vue";

export default {
  name: "OperationsLicenses",
  components: {
    OperationsTitle,
    OperationLicensesList,
  },
  props: {
    operation: { type: Object, required: true },
  },
};
</script>

<style scoped></style>
